import { IFieldContainer, IFieldDefinition, IFormConfig } from 'app/interfaces';
import { fieldsMap } from '../fields';

const formFields: (IFieldContainer|IFieldDefinition)[] = [
	// indicare campi
];

const config: IFormConfig = {
	title: 'Crea Plafond Item',
	editTitle: 'Modifica Plafond Item',
	fields: formFields 
};

export default config;
